module.exports = __webpack_public_path__ + "img/pluska-logo.269e0f1c.svg";